export const neurosurgeryConst = {
  path: "/single-programs/neurosurgery",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — НЕЙРОХИРУРГИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <br />
      <p>
        Нейрохирургия занимается оперативным лечением заболеваний головного и спинного мозга, позвоночника и нервов. Обучение включает
        анатомию центральной и периферической нервной системы, методы нейровизуализации, микронейрохирургию, а также современные подходы к
        лечению опухолей, травм и сосудистых нарушений.
      </p>
      <p>
        Будущие специалисты осваивают работу с высокоточным оборудованием, учатся проводить сложные нейрохирургические вмешательства и
        разрабатывать тактику лечения пациентов с тяжелыми неврологическими патологиями. Программа также включает практическую подготовку и
        клинические стажировки.
      </p>
      <h2>Кем можно работать:</h2>
      <ul>
        <li>Нейрохирург</li>
        <li>Спинальный хирург</li>
        <li>Врач-нейротравматолог</li>
        <li>Нейрохирург-онколог</li>
        <li>Специалист по сосудистой нейрохирургии</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€80,000 до €160,000 в год</strong>
      </p>
      <p>в зависимости от специализации, страны и уровня клиники</p>
      <h2>Как поступить?</h2>
      <p>Узнайте подробнее о программе, стоимости и документах — отправьте заявку прямо сейчас. </p>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Форма обучения: очно или дистанционно
    Форма: Получить консультацию приемной комиссии
    Нейрохирургия занимается оперативным лечением заболеваний головного и спинного мозга, позвоночника и нервов. Обучение включает анатомию центральной и периферической нервной системы, методы нейровизуализации, микронейрохирургию, а также современные подходы к лечению опухолей, травм и сосудистых нарушений.
    Будущие специалисты осваивают работу с высокоточным оборудованием, учатся проводить сложные нейрохирургические вмешательства и разрабатывать тактику лечения пациентов с тяжелыми неврологическими патологиями. Программа также включает практическую подготовку и клинические стажировки.

    Кем можно работать:
    Нейрохирург
    Спинальный хирург
    Врач-нейротравматолог
    Нейрохирург-онколог
    Специалист по сосудистой нейрохирургии

    Зарплата в Европе:
    от €80,000 до €160,000 в год
    в зависимости от специализации, страны и уровня клиники

    Как поступить?
    Узнайте подробнее о программе, стоимости и документах — отправьте заявку прямо сейчас. 
  `,
};
